<div class="map-menu-item" *ngIf="selectedBoundaries$ | async as selectedBoundaries">
  <div class="header header--default">
    <h3 class="p-0 border-0">Boundaries</h3>
  </div>
  <ul class="boundaries-list p-0 m-0" (click)="$event.stopPropagation()">
    <li mat-menu-item role="menuitemcheckbox" *ngFor="let layer of boundaryLayers$ | async; trackBy: trackByFn" class="map-layer">
      <label class="custom-control custom-checkbox boundaries-list__label"
             tabindex="0"
             [ngClass]="{'custom-control--disabled': layersLimitReached && !layer.isSelected}">
        <input type="checkbox"
               class="custom-control-input checkbox-default"
               [disabled]="layersLimitReached && !layer.isSelected"
               [checked]="layer.isSelected"
               (change)="toggleBoundary(layer)">
        <span class="custom-control-indicator"></span>
        <span class="layer-color-block"
              [ngStyle]="{backgroundColor: layer.color}"
              [ngClass]="layer.iconClass">
        </span>
        <span class="layer-text">{{layer.label}}</span>
      </label>
      <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomIn" rlstTooltip="Zoom In" [tooltipPosition]="'above'">
        <i class="far fa-search-plus" aria-hidden="true"></i>
        <span class="sr-only">Zoom In</span>
      </p>
      <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomOut" rlstTooltip="Zoom Out" [tooltipPosition]="'above'">
        <i class="far fa-search-minus" aria-hidden="true"></i>
        <span class="sr-only">Zoom Out</span>
      </p>
    </li>
  </ul>
  <div class="info-lane info-lane--default">
    <rlst-map-layers-info-footer></rlst-map-layers-info-footer>
  </div>
</div>
